import {
  NarsDashboard,
  NarsTasks,
  NarsLayout,
} from "@/components/atomic-crm/layout/NarsWorkspace";
import {
  NarsClientList,
  NarsClientCreate,
  NarsClientEdit,
  NarsClientShow,
} from "@/components/atomic-crm/contacts/NarsClients";
import { CRM } from "@/components/atomic-crm/root/CRM";
import { narsI18nProvider } from "@/nars/i18nProvider";
import { narsConfiguration } from "@/nars/configuration";
import { localStorageStore } from "ra-core";

// Keep NARS preferences separate from the original Atomic demo preferences.
// This does not alter backend records or erase the previous browser store.
const narsStore = localStorageStore("1", "NARS-CRM");

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - darkModeLogo / lightModeLogo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * Logos must be an imported asset, an absolute URL, or a data URI — never a
 * route-relative path like "./img/logo.png", which breaks on nested routes.
 *
 * @example
 * import logoDark from "./logo-dark.svg";
 * import logoLight from "./logo-light.svg";
 *
 * const App = () => (
 *    <CRM
 *       darkModeLogo={logoDark}
 *       lightModeLogo={logoLight}
 *       title="Acme CRM"
 *    />
 * );
 */
const App = () => (
  <CRM
    {...narsConfiguration}
    layout={NarsLayout}
    dashboard={NarsDashboard}
    taskList={NarsTasks}
    contactViews={{
      list: NarsClientList,
      create: NarsClientCreate,
      edit: NarsClientEdit,
      show: NarsClientShow,
    }}
    store={narsStore}
    i18nProvider={narsI18nProvider}
    disableTelemetry
  />
);

export default App;
